import deleteUserConfigurationOperation from 'owa-service/lib/operation/deleteUserConfigurationOperation';
import deleteUserConfigurationRequest from 'owa-service/lib/factory/deleteUserConfigurationRequest';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import getMailboxExportUserConfigurationName from './getMailboxExportUserConfigurationName';

export default async function deleteMailboxExportRequest() {
    await deleteUserConfigurationOperation({
        Header: getJsonRequestHeader(),
        Body: deleteUserConfigurationRequest({
            UserConfigurationName: getMailboxExportUserConfigurationName(),
        }),
    });
}
